import React from 'react'
import MainLayout from '../Layouts/Mainlayout'
import NewRequestImport from './NewRequestImport'

function NewRequestWrapper(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <NewRequestImport />
      </MainLayout>
    </div>
  )
}

export default NewRequestWrapper